import { memo, useCallback, useState } from 'react';
import { NodeResizer, useReactFlow } from 'reactflow';

export default memo(({ id, data, selected }: any) => {
    const { setNodes } = useReactFlow();
    const [isEditing, setIsEditing] = useState(false);

    const onChange = useCallback((evt: any) => {
        const val = evt.target.value;
        setNodes((nds) => nds.map((n) => {
            if (n.id === id) {
                return { ...n, data: { ...n.data, label: val } };
            }
            return n;
        }));
    }, [id, setNodes]);

    return (
        <div className="h-full w-full relative group min-w-[100px] min-h-[30px] flex flex-col bg-yellow-50/80 rounded border border-yellow-200 hover:border-yellow-400 focus-within:border-yellow-400 focus-within:ring-2 focus-within:ring-yellow-400/20 transition-all shadow-sm overflow-hidden">
            
            {/* Direct Editable Text Area */}
            <textarea
                className={`${isEditing ? 'nodrag' : ''} nowheel w-full h-full flex-1 p-1.5 px-2 bg-transparent border-0 resize-none focus:outline-none font-mono leading-relaxed text-slate-700 placeholder:text-slate-400 cursor-text`}
                value={data.label || ''}
                onChange={onChange}
                onFocus={() => setIsEditing(true)}
                onBlur={() => setIsEditing(false)}
                placeholder="Type comment..."
                style={{
                    fontSize: '8px',
                    whiteSpace: 'pre-wrap'
                }}
            />

            <NodeResizer
                color="#eab308"
                isVisible={selected}
                minWidth={100}
                minHeight={30}
                handleStyle={{ width: 8, height: 8, borderRadius: 2 }}
            />
        </div>
    );
});
